
define(
	'C25.CaterpartsCCTs.Main'
,   [
		'C25.Blog.View',
		'C25.BlogList.View',
		'C25.Banner.View',
		'C25.Categories.View'
	]
,   function (
	BlogView,
		BlogListView,
		BannerView,
		CategoriesView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var CMS = container.getComponent('CMS');
				
				CMS.registerCustomContentType({
					id: 'custcontenttype_c25_blog'
					, view: BlogView
				});

				CMS.registerCustomContentType({
					id: 'custcontenttype_c25_bloglist'
					, view: BlogListView
				});

				CMS.registerCustomContentType({
					id: 'custcontenttype_c25_banner'
					, view: BannerView
				});

				CMS.registerCustomContentType({
					id: 'custcontenttype_c25_categories'
					, view: CategoriesView
				});
		}
	};
});
